"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button = function (props) { return (React.createElement("button", { type: "button", className: "button red-button ".concat(props.disabled() === true ? 'disabled-button' : null), onClick: props.method, disabled: typeof props.disabled === 'function' ? props.disabled() : props.disabled }, props.label)); };
exports.default = Button;
